import z from 'zod';

export const addBalanceRequestSchema = z.object({
  amount: z
    .number({ required_error: 'Amount is required' })
    .positive('Amount must be greater than 0'),
  currency: z
    .string()
    .length(3, 'Currency must be a 3-letter code like USD, INR, EUR'),
  walletType: z.enum(['prepaid', 'postpaid']).optional(),
  description: z.string().optional(),
  reason: z.string().optional(),
  metadata: z.record(z.unknown()).optional(),
});

export type AddBalanceType = z.infer<typeof addBalanceRequestSchema>;
